import {Component, Input} from '@angular/core';

@Component({
  selector: 'divider',
  standalone: true,
  template: '',
  host: {
    class: 'border-left border-bottom',
    '[style.borderLeftWidth]': 'borderWidth + " !important"',
    '[style.borderBottomWidth]': 'borderWidth + " !important"',
  }
})
export class TitanDivider {
  @Input() borderWidth: string = '1px';
}
